import { validContentSlug } from './seo.js';

export function storyImageUrl(apiBase, picture) {
  const filename = validContentSlug(picture);
  return filename
    ? `${String(apiBase).replace(/\/$/, '')}/uploads/stories/${encodeURIComponent(filename)}`
    : '';
}
export function editorialStories(data) {
  return (Array.isArray(data?.items) ? data.items : [])
    .filter((story) => story && validContentSlug(story.picture))
    .slice(0, 3)
    .map((story) => ({
      picture: validContentSlug(story.picture),
      name: typeof story.name === 'string' ? story.name : '',
      package: {
        title:
          typeof story.package?.title === 'string' ? story.package.title : ''
      }
    }));
}
/** Shared card data without a listing limit; only the homepage preview is capped. */
export function articlePosts(records) {
  return (Array.isArray(records) ? records : [])
    .filter(
      (post) =>
        post &&
        validContentSlug(post.slug) &&
        typeof post.title === 'string' &&
        post.title.trim()
    )
    .map((post) => ({
      id: post.id,
      slug: validContentSlug(post.slug),
      title: post.title,
      image:
        [post.image, post.picture].find(
          (value) => typeof value === 'string' && value
        ) || '',
      thumbnail: typeof post.thumbnail === 'string' ? post.thumbnail : '',
      shortDescription: plainExcerpt(
        [
          post.shortDescription,
          post.short_description,
          post.excerpt,
          post.description,
          post.summary
        ].find((value) => typeof value === 'string' && value.trim()) || ''
      ),
      category: {
        name: typeof post.category?.name === 'string' ? post.category.name : ''
      },
      date: { timestamp: post.date?.timestamp }
    }));
}
export function editorialPosts(data) {
  return articlePosts(data?.posts).slice(0, 3);
}
export function plainExcerpt(html, max = 180) {
  if (typeof html !== 'string') return '';
  const text = html
    .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, ' ')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
  if (text.length <= max) return text;
  const cut = text.slice(0, max);
  const boundary = cut.lastIndexOf(' ');
  return `${(boundary >= max - 30 ? cut.slice(0, boundary) : cut).trimEnd()}…`;
}
export function articleDate(post, locale) {
  const timestamp = post?.date?.timestamp;
  if (typeof timestamp !== 'string' || !/^\d{4}-\d{2}-\d{2}T/.test(timestamp))
    return null;
  const date = new Date(timestamp);
  if (!Number.isFinite(date.getTime())) return null;
  return {
    iso: date.toISOString(),
    label: new Intl.DateTimeFormat(locale, {
      dateStyle: 'medium',
      timeZone: 'UTC'
    }).format(date)
  };
}
